<template>
    <v-container max-width="1200">
        <SurveyComponent :model="survey"></SurveyComponent>
    </v-container>
</template>

<script>
import { Model } from 'survey-core'
import { SurveyComponent } from 'survey-vue3-ui'
import 'survey-core/survey-core.css'
import { FlatDarkPanelless } from "survey-core/themes"
import axios from 'axios'

export default {
    name: 'SurveyForm',

    components: {
        SurveyComponent
    },

    data: () => ({
        surveyJson: {
            completedBeforeHtml: "<h3 style='margin-top: 30px;'>You have already completed this survey.</h3><br/><br/>",
            cookieName: "aurora-survey",
            title: "AuroraFinder User Satisfaction Survey",
            completedHtml: "<h3>Thank you for your feedback</h3><br/><br/>",
            elements: [
                {
                    name: "q1",
                    title: "Was it easy to understand and use the AuroraFinder app?",
                    isRequired: true,
                    type: "boolean",
                },
                {
                    name: "q2",
                    title: "Are the videos clear to see when aurora are vivid or brilliant?",
                    isRequired: true,
                    type: "boolean",
                },
                {
                    name: "q3",
                    title: "Is the video streaming smoothly?",
                    isRequired: true,
                    type: "boolean",
                },
                {
                    name: "q4",
                    title: "Is the notification system easy to understand and use?",
                    isRequired: true,
                    type: "boolean",
                },
                {
                    name: "q5",
                    title: "Does the notification system work as you would like it to?",
                    isRequired: true,
                    type: "boolean",
                },
                {
                    name: "comment",
                    title: "If you have any suggestions please note them here.",
                    type: "comment",
                }
            ]
        }
    }),

    methods: {
        saveSurveyResults(json) {
            let data = {
                response: json,
            }
            axios.post('survey', data)
            .then(response => {
                if (response.ok) {
                // Handle success
                } else {
                // Handle error
                }
            })
            .catch(() => {
            });
        }
    },

    created() {
        const surveyComplete = (survey) => {
            const results = JSON.stringify(survey.data)
            // alert(results)   
            this.saveSurveyResults(results)
        }

        this.survey = new Model(this.surveyJson)
        this.survey.applyTheme(FlatDarkPanelless)
        this.survey.onComplete.add(surveyComplete)
    }
}
</script>